<template>
  <div class="news-container">
    <div class="news-block news-banner" v-loading="loading.banner">
      <swiper v-if="banners.length" :options="swiperOption" style="height: 100%;width: 100%;">
        <swiper-slide
          class="swiper-item"
          v-for="(item, index) in banners"
          :key="index">
          <div
            class="swiper-item-img"
            :style="{backgroundImage: `url(${$assetsPath + item.imgUrl})`}"
          >
            <div class="swiper-item-title">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </swiper-slide>
        <!-- 分页器 -->
        <div class="swiper-pagination"  slot="pagination"></div>
        <!-- 左右箭头 -->
        <!--      <div class="swiper-button-prev" slot="button-prev"></div>-->
        <!--      <div class="swiper-button-next" slot="button-next"></div>-->
      </swiper>
    </div>
    <div class="news-block news-list" v-loading="loading.party">
      <div
        v-for="(item, index) in party"
        :key="index"
        class="news-list-item"
        @click="toDetail(item)">
        <div
          class="news-list-item-img"
          :style="{backgroundImage: `url(${$assetsPath + item.imgUrl})`}"
        ></div>
        <div class="news-list-item-content">
          <div class="news-list-item-title">{{ item.title }}</div>
          <div class="news-list-item-desc">{{ item.remark }}</div>
          <div class="news-list-item-time">{{ $parseTime(item.publishTime, '{y}-{m}-{d}') }}</div>
        </div>
      </div>
    </div>
    <div class="news-block news-small-container news-association-container" v-loading="loading.news">
      <small-header title="协会要闻" moreLink="/association" more></small-header>
      <div class="news-small-list">
        <div
          v-for="(item, index) in news"
          :key="index"
          class="news-small-list-item"
          @click="toDetail(item)"
        >
          <div class="news-small-list-item-title">{{ item.title }}</div>
          <div class="news-small-list-item-time">{{ $parseTime(item.publishTime, '{y}-{m}-{d}') }}</div>
        </div>
      </div>
    </div>
    <div class="news-small-block">
      <div class="news-small-container" v-loading="loading.policy">
        <small-header title="政策法规" moreLink="/policy" more></small-header>
        <div class="news-small-list">
          <div
            v-for="(item, index) in policy"
            :key="index"
            class="news-small-list-item"
            @click="toDetail(item)">
            <div class="news-small-list-item-title">{{ item.title }}</div>
            <div class="news-small-list-item-time">{{ $parseTime(item.publishTime, '{y}-{m}-{d}') }}</div>
          </div>
        </div>
      </div>
      <div class="news-small-container" v-loading="loading.publicity">
        <small-header title="公示公告" moreLink="/publicity" more></small-header>
        <div class="news-small-list">
          <div
            v-for="(item, index) in publicity"
            :key="index"
            class="news-small-list-item"
            @click="toDetail(item)">
            <div class="news-small-list-item-title">{{ item.title }}</div>
            <div class="news-small-list-item-time">{{ $parseTime(item.publishTime, '{y}-{m}-{d}') }}</div>
          </div>
        </div>
      </div>
<!--      <div class="news-small-container" v-loading="loading.notice">-->
<!--        <small-header title="文件通知" moreLink="/notice" more></small-header>-->
<!--        <div class="news-small-list">-->
<!--          <div-->
<!--            v-for="(item, index) in notice"-->
<!--            :key="index"-->
<!--            class="news-small-list-item"-->
<!--            @click="toDetail(item)">-->
<!--            <div class="news-small-list-item-title">{{ item.title }}</div>-->
<!--            <div class="news-small-list-item-time">{{ $parseTime(item.publishTime, '{y}-{m}-{d}') }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getBanner, getPartyList, getNewsList, getPolicyList, getPublicityList, getNoticeList } from '@/api'

export default {
  props: {
    knowledgeTypes: {
      type: Array
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption:{
        //显示分页
        pagination: {
          el: '.swiper-pagination'
          // dynamicBullets: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true
      },
      banners: [],
      party: [],
      news: [],
      policy: [],
      publicity: [],
      notice: [],
      loading: {
        banner: true,
        party: true,
        news: true,
        policy: true,
        publicity: true,
        notice: true
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      getBanner().then(res => {
        this.banners = res.data
        this.loading.banner = false
      })
      getPartyList().then(res => {
        this.party = res.rows.slice(0, 3)
        this.loading.party = false
      })
      getNewsList().then(res => {
        this.news = res.rows.slice(0, 8)
        this.loading.news = false
      })
      getPolicyList().then(res => {
        this.policy = res.rows.slice(0, 3)
        this.loading.policy = false
      })
      getPublicityList().then(res => {
        this.publicity = res.rows.slice(0, 3)
        this.loading.publicity = false
      })
      getNoticeList().then(res => {
        this.notice = res.rows
        this.loading.notice = false
      })
    },
    toDetail(obj) {
      this.$setCurArticle(obj)
      this.$router.push('/news-detail')
    }
  }
}
</script>

<style lang="scss">
.news-container {
  .swiper-pagination {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content:flex-end;
    text-align: right;
    position: absolute;
    bottom: 0 !important;
    right: 20px;
    width: auto !important;
  }
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    transition: all 300ms;
  }

  .swiper-pagination-bullet-active {
    width: 16px;
    border-radius: 4px;
  }
}
</style>
<style lang="scss" scoped>
.news-container {
  width: 1200px;
  margin: 50px auto 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  .news-block {
    flex: 0 0 49%;
    height: 430px;
    position: relative;
  }
  .news-small-block {
    flex: 0 0 49%;
    height: 592px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-top: 60px;
    .news-small-container {
      margin: 0 !important;
    }
  }
  .news-banner {
    overflow: hidden;
    .swiper-item-img {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center center;
      position: relative;
      .swiper-item-title {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 60px;
        background: rgba(#1279EC, 0.7);
        line-height: 60px;
        padding: 0 20px;
        color: #fff;
        font-size: 20px;
        span {
          display: inline-block;
          width: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .news-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    * {
      transition: all 300ms;
    }
    .news-list-item {
      width: 585px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      background: #fff;
      .news-list-item-img {
        width: 200px;
        height: 130px;
        background-size: cover;
        background-position: center center;
      }
      .news-list-item-content {
        margin-left: 30px;
        padding-right: 30px;
        .news-list-item-title {
          width: 321px;
          font-size: 20px;
          font-weight: bold;
          color: #1C4281;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .news-list-item-desc {
          width: 325px;
          font-size: 16px;
          font-weight: 400;
          color: #484E54;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .news-list-item-time {
          font-size: 16px;
          font-weight: 400;
          color: #8F98A0;
          line-height: 30px;
        }
      }
    }
    .news-list-item:hover {
      background: #1279EC;
      .news-list-item-title,.news-list-item-desc,.news-list-item-time {
        color: #fff;
      }
    }
  }
  .news-association-container {
    height: 592px !important;
  }
  .news-small-container {
    width: 100%;
    height: 269px;
    margin-top: 60px;
    background: #fff;
    border-bottom: 4px solid #0077FE;
    .news-small-list {
      padding: 0 30px;
      margin-top: 10px;
      .news-small-list-item {
        line-height: 65px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border-top: 1px dashed #CBD0D5;
        .news-small-list-item-title {
          width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 18px;
          color: #484E54;
          transition: all 300ms;
        }
        .news-small-list-item-time {
          font-size: 18px;
          color: #8F98A0;
          transition: all 300ms;
        }
      }
      .news-small-list-item:nth-child(1) {
        border: none;
      }
      .news-small-list-item:hover {
        .news-small-list-item-title,.news-small-list-item-time {
          color: #1279EC;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/News/index.vue